import React from 'react';
import { useTranslation } from 'react-i18next';
import { Globe } from 'lucide-react';

export default function LangToggle() {
  const { i18n } = useTranslation();

  const toggleLang = () => {
    const newLang = i18n.language === 'ar' ? 'en' : 'ar';
    i18n.changeLanguage(newLang);
    localStorage.setItem('lang', newLang);
    document.documentElement.dir = newLang === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.lang = newLang;
  };

  return (
    <button
      onClick={toggleLang}
      className="flex items-center gap-2 text-text-secondary hover:text-accent transition-colors duration-200 px-3 py-2 rounded-lg hover:bg-white/5"
    >
      <Globe size={18} />
      <span className="text-sm font-medium">
        {i18n.language === 'ar' ? 'EN' : 'ع'}
      </span>
    </button>
  );
}
